/*
 * Copyright 2025, IntraLinks, Inc. All rights reserved.
 */

import { IAdaptor } from '../utils/IAdaptor';
import { ILoaIntegration } from '../../../domain/models/ILoaIntegration';
import LoaIntegrationDto from '../../dto/LoaIntegrationDto';

export default class LoaIntegrationAdaptor implements IAdaptor<ILoaIntegration, LoaIntegrationDto> {
  /**
     * This property is used to map properties from FE to properties in BE, such that when requesting some fields,
     * or filtering by some fields, the infrastructure layer knows what to request from the BE.
     * */
  domainToDtoPropertiesMap: { [K in keyof ILoaIntegration]?: keyof LoaIntegrationDto } = {
    id: 'id',
    name: 'name',
    level: 'level'
  };

  /**
     * This is used mostly when we do get calls, so that data from BE is properly mapped to data in FE
     */
  fromDto(dto: LoaIntegrationDto): Partial<ILoaIntegration> {
    return {
      id: dto.id,
      name: dto.name,
      level: dto.level
    };
  }

  /**
     * This function is used to map FE Domain models to BE models.
     * It will be called when we send a domain model to the infrastructure, and it needs to send a Dto to BE (post, patch, put).
     * Bear in mind that you can just write the properties that you use,
     * no need to add the properties that you don't need to send over the network.
     */
  toDto(model: Partial<ILoaIntegration>): Partial<LoaIntegrationDto> {
    return {
      id: model.id,
      name: model.name,
      level: model.level
    };
  }
}
